
  import React from "react"
  import Component from "/Users/jorge/Sites/jorgemancheno.com/src/layouts/index.js"
  import data from "/Users/jorge/Sites/jorgemancheno.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js